export default __webpack_public_path__ + "static/media/e-check.553ec948.svg";